module.exports = __webpack_public_path__ + "static/media/etsy-floral-throw.973d076d.png";